import { render, staticRenderFns } from "./codeviolations.vue?vue&type=template&id=1f90273f&scoped=true"
import script from "./codeviolations.vue?vue&type=script&lang=js"
export * from "./codeviolations.vue?vue&type=script&lang=js"
import style0 from "./codeviolations.vue?vue&type=style&index=0&id=1f90273f&prod&lang=css"
import style1 from "./codeviolations.vue?vue&type=style&index=1&id=1f90273f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90273f",
  null
  
)

export default component.exports